import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import { getCheckinOrder } from '@websky/core/src/Modules/Checkin/store/order/selectors';
import { ModeContext } from '@websky/core/src/context';
import { Mode } from '@websky/core/src/types';
import PricePartsComponent from '@websky/core/src/PaymentForm/components/PriceParts/PriceParts';
import { getUnpaidGdsServicesCountByRfisc } from './utils';
const PriceParts = props => {
    var _a, _b, _c, _d, _e;
    const mode = React.useContext(ModeContext);
    let additionalServices = {};
    let unpaidServiceFeeCount;
    if (mode === Mode.Checkin) {
        additionalServices = useSelector(getCheckinOrder).additionalServices;
        unpaidServiceFeeCount = getUnpaidGdsServicesCountByRfisc(useSelector(getCheckinOrder));
    }
    else {
        additionalServices = useSelector(getOrder).additionalServices;
        unpaidServiceFeeCount = getUnpaidGdsServicesCountByRfisc(useSelector(getOrder));
    }
    const serviceFee = (_b = (_a = additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.find(service => service.rfisc === 'RG1');
    const pricesWithServiceFee = serviceFee && unpaidServiceFeeCount
        ? Object.assign(Object.assign({}, props.prices), { vip: Object.assign(Object.assign({}, props.prices.vip), { amount: ((_c = props.prices.vip) === null || _c === void 0 ? void 0 : _c.amount) - unpaidServiceFeeCount * ((_d = serviceFee.price) === null || _d === void 0 ? void 0 : _d.amount) }), [serviceFee.name]: Object.assign(Object.assign({}, props.prices.vip), { amount: unpaidServiceFeeCount * ((_e = serviceFee.price) === null || _e === void 0 ? void 0 : _e.amount) }) }) : props.prices;
    return React.createElement(PricePartsComponent, Object.assign({}, props, { prices: pricesWithServiceFee }));
};
export default PriceParts;
